import { Col } from "react-bootstrap";
import { ArrowRightCircle } from 'react-bootstrap-icons';
import React, { useState } from 'react';

export const ProjectCard = ({ title, description, imgUrl, linkHref, content }) => {
  const [showModal, setShowModal] = useState(false);

  const handleClick = () => setShowModal(true);
  const handleClose = () => setShowModal(false);
  
  return (
      <Col size={12} sm={6} md={4} className="m-auto">
        <div className="proj-imgbx">
          <img src={imgUrl} />
          <div className="proj-txtx">
            <h4>{title}</h4>
            <span>{description}</span>
            <button onClick={handleClick}><ArrowRightCircle size={25} /></button>
          </div>
        </div>
        <div className="card">
          {showModal && (
            <div className="proj-modal">
              <button onClick={handleClose}>Close</button>
              <div>
                <img src={imgUrl} />
                <div className="proj-content">
                  <h2>{title}</h2>
                  <p>{content}</p>
                  <p className="mt-4">Link: <a href={linkHref} target="_blank">{title}</a></p>
                </div>
              </div>
            </div>
          )}
        </div>
      </Col>

  )
}